import {FC, MouseEventHandler} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import Icon from 'components/Icon';
import {ru} from 'date-fns/locale';
import {format} from 'date-fns';

interface IProps {
    onLikeClick: () => void;
    onDislikeClick: () => void;
    likes?: number;
    dislikes?: number;
    isLike?: boolean;
    isDislike?: boolean;
    onCommentToggle?: () => void;
    isCommentText?: boolean;
    date?: string;
}

export const ProductReviewCardActions: FC<IProps> = ({
    onDislikeClick,
    onLikeClick,
    dislikes,
    likes,
    isDislike,
    isLike,
    onCommentToggle,
    isCommentText = true,
    date = '',
}) => {
    const onLike: MouseEventHandler<HTMLDivElement> = (e) => {
        e.preventDefault();
        onLikeClick();
    };

    const onDislike: MouseEventHandler<HTMLDivElement> = (e) => {
        e.preventDefault();
        onDislikeClick();
    };

    const isCurrentYear = new Date(date).getUTCFullYear() === new Date().getUTCFullYear();
    const dateFormatted = !isCurrentYear
        ? format(new Date(date), 'dd.MM.yy', {locale: ru})
        : format(new Date(date), 'd MMMM', {locale: ru});

    return (
        <div className={style.actions}>
            <div
                className={classNames(style.reaction, style.reactionLike, {[style.isReaction]: isLike})}
                onClick={onLike}
            >
                <div className={style.emoji}>
                    <div className={style.like}>👍</div>
                </div>
                {Boolean(likes) && (
                    <Typography variant={'label-16-r'} color={'gray60'}>
                        {likes}
                    </Typography>
                )}
            </div>
            <div className={classNames(style.reaction, {[style.isReaction]: isDislike})} onClick={onDislike}>
                <div className={style.emoji}>
                    <div className={style.dislike}>👎</div>
                </div>
                {Boolean(dislikes) && (
                    <Typography variant={'label-16-r'} color={'gray60'}>
                        {dislikes}
                    </Typography>
                )}
            </div>
            <div className={style.commentBtn} onClick={onCommentToggle}>
                <Icon className={style.commentIcon} icon={'comment'} />
                {isCommentText ? (
                    <Typography className={style.commentBtnText} color={'gray60'}>
                        Комментировать
                    </Typography>
                ) : (
                    <div />
                )}
            </div>
            <Typography className={style.date} color={'gray60'} variant={'label-14-r-fluid'}>
                {dateFormatted}
            </Typography>
        </div>
    );
};
